import { Button, Popconfirm, Form } from 'antd';
import { useCallback, useEffect, useState, useTransition } from 'react';
import { useTranslation } from 'react-i18next';
import FormItem from '../../../../components/fields/FormItem';
import { InputNumber } from '../../../../components/fields/InputNumberField';

type RowFormPopupProps = {
    label: string;
    value: number;
    onChange: (newValue: number) => void;
};

const rowValidation = { min: 1, max: 999 };

const rowFieldStyle = { style: { width: 130 } };

const RowFormPopup = ({ label, value, onChange }: RowFormPopupProps) => {
    const { t } = useTranslation(['common']);
    const [, startTransition] = useTransition();

    const [meta, setMeta] = useState<{
        touched: boolean;
        error: string | null;
        initialValue?: number;
        value: number;
    }>({
        touched: false,
        error: null,
        value,
    });

    useEffect(() => {
        // Delaying validation to prevent jitter
        startTransition(() => {
            let error = null;
            if (value > rowValidation.max) {
                error = t('common:formErrors.numberBetween', rowValidation);
            }

            if (value < rowValidation.min) {
                error = t('common:formErrors.numberBetween', rowValidation);
            }

            setMeta({ error, touched: true, value });
        });
    }, [t, value]);

    return (
        <Form layout="inline">
            <FormItem label={label} meta={meta} wrapperCol={rowFieldStyle}>
                <InputNumber onChange={onChange} style={{ width: '100%' }} type="number" value={value} />
            </FormItem>
        </Form>
    );
};

const AddRow = ({ onAdd }: { onAdd: (val: number) => void }) => {
    const { t } = useTranslation(['financeProductDetails']);
    const [value, setValue] = useState(1);

    const handleSubmit = useCallback(() => {
        onAdd(value);
    }, [onAdd, value]);

    return (
        <Popconfirm
            cancelText={t('financeProductDetails:actions.cancel')}
            okText={t('financeProductDetails:actions.add')}
            onCancel={() => setValue(1)}
            onConfirm={handleSubmit}
            placement="topRight"
            title={
                <RowFormPopup
                    label={t('financeProductDetails:messages.addRow.title')}
                    onChange={setValue}
                    value={value}
                />
            }
        >
            <Button size="middle" type="primary">
                {t('financeProductDetails:actions.addRow')}
            </Button>
        </Popconfirm>
    );
};

export default AddRow;
